/* ════════════════════════════════════════════════
   Installa Frogames · JS
   - Rileva standalone mode (chi apre da home → schermata "già nel club")
   - Auto-suggerisce il device giusto in base allo user agent
   - Gestisce navigazione step + sub-toggle browser (Chrome/Samsung)
   - Intercetta beforeinstallprompt su Android → bottone "Installa con un tap"
   - Salva conferma in localStorage con naming generico per Fase 2 (multi-canale)
   ════════════════════════════════════════════════ */

(function () {
  'use strict';

  const root = document.querySelector('[data-ifg-root]');
  if (!root) return;

  // ─── DETECTION: standalone (già installato e aperto da icona) ───
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    document.referrer.startsWith('android-app://');

  if (isStandalone) {
    // Standalone = aperto da icona Home. Mostriamo solo schermata "già nel club".
    // NON persistiamo lo status: se l'utente poi disinstalla, il rilevamento
    // standalone smette automaticamente di scattare. Conferma "vera" solo da
    // tutorial completato o evento appinstalled.
    root.querySelector('[data-ifg-already]').hidden = false;
    root.querySelector('[data-ifg-main]').hidden = true;
    return;
  }

  // ─── DETECTION: device / browser via user agent ───
  const ua = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/.test(ua);
  const isSamsung = /SamsungBrowser/.test(ua);
  const isChromeIOS = isIOS && /CriOS/.test(ua);
  const isDesktop = !isIOS && !isAndroid;

  // Default browser per device based on UA
  const defaultBrowserForIOS = isChromeIOS ? 'chrome' : 'safari';
  const defaultBrowserForAndroid = isSamsung ? 'samsung' : 'chrome';

  // Desktop notice
  if (isDesktop) {
    const notice = root.querySelector('[data-ifg-desktop-notice]');
    if (notice) notice.hidden = false;
  }

  // Pre-suggest the right device
  if (isIOS) {
    root.querySelector('[data-ifg-pick="ios"]')?.classList.add('is-suggested');
  } else if (isAndroid) {
    root.querySelector('[data-ifg-pick="android"]')?.classList.add('is-suggested');
  }

  // ─── STATE (generic naming for future multi-channel hub) ───
  const STATE_KEY = 'frogames_channels';

  function getState() {
    try { return JSON.parse(localStorage.getItem(STATE_KEY) || '{}'); }
    catch { return {}; }
  }
  function setChannel(channel, patch) {
    const s = getState();
    s[channel] = Object.assign({}, s[channel] || {}, patch);
    try { localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch {}
  }

  // ─── FLOW STATE ───
  const panels = root.querySelectorAll('[data-ifg-panel]');
  let currentDevice = null;       // 'ios' | 'android'
  let currentBrowser = 'safari';  // 'safari'|'chrome' (ios) · 'chrome'|'samsung' (android)
  let currentStep = 1;

  // ─── PANEL SWITCHER ───
  function showPanel(name) {
    panels.forEach(p => { p.hidden = p.dataset.ifgPanel !== name; });
    const flow = root.querySelector('[data-ifg-flow]');
    if (flow) flow.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── STEP SWITCHER ───
  // Prefix unificato: `${device}-${browser}-${step}`
  // → ios-safari-1, ios-chrome-1, android-chrome-1, android-samsung-1
  function showStep(device, browser, step) {
    const panel = root.querySelector(`[data-ifg-panel="${device}"]`);
    if (!panel) return;

    const prefix = `${device}-${browser}`;
    panel.querySelectorAll('[data-ifg-step]').forEach(s => {
      s.hidden = s.dataset.ifgStep !== `${prefix}-${step}`;
    });

    // Progress dots
    panel.querySelectorAll('[data-ifg-dot]').forEach(dot => {
      dot.classList.toggle('is-active', Number(dot.dataset.ifgDot) <= step);
    });

    // Nav buttons
    const prevBtn = panel.querySelector('[data-ifg-prev]');
    const nextBtn = panel.querySelector('[data-ifg-next]');
    const doneBtn = panel.querySelector('[data-ifg-done]');
    if (prevBtn) prevBtn.hidden = step === 1;
    if (nextBtn) nextBtn.hidden = step === 3;
    if (doneBtn) doneBtn.hidden = step !== 3;
  }

  // ─── EVENT: device picker ───
  root.querySelectorAll('[data-ifg-pick]').forEach(btn => {
    btn.addEventListener('click', () => {
      currentDevice = btn.dataset.ifgPick;
      currentStep = 1;
      currentBrowser = currentDevice === 'ios' ? defaultBrowserForIOS : defaultBrowserForAndroid;

      // Reflect default browser in toggle UI (within the active panel)
      const panel = root.querySelector(`[data-ifg-panel="${currentDevice}"]`);
      if (panel) {
        panel.querySelectorAll('[data-ifg-browser]').forEach(b => {
          b.classList.toggle('is-active', b.dataset.ifgBrowser === currentBrowser);
        });
        panel.querySelectorAll('[data-ifg-browser-content]').forEach(c => {
          c.hidden = c.dataset.ifgBrowserContent !== currentBrowser;
        });
      }

      showPanel(currentDevice);
      showStep(currentDevice, currentBrowser, 1);
    });
  });

  // ─── EVENT: browser sub-toggle (works for both iOS and Android panels) ───
  root.querySelectorAll('[data-ifg-browser]').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('[data-ifg-panel]');
      if (!panel) return;

      currentBrowser = btn.dataset.ifgBrowser;
      currentStep = 1;

      panel.querySelectorAll('[data-ifg-browser]').forEach(b => {
        b.classList.toggle('is-active', b === btn);
      });
      panel.querySelectorAll('[data-ifg-browser-content]').forEach(c => {
        c.hidden = c.dataset.ifgBrowserContent !== currentBrowser;
      });

      showStep(currentDevice, currentBrowser, 1);
    });
  });

  // ─── EVENT: next ───
  root.querySelectorAll('[data-ifg-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (currentStep < 3) {
        currentStep++;
        showStep(currentDevice, currentBrowser, currentStep);
      }
    });
  });

  // ─── EVENT: prev ───
  root.querySelectorAll('[data-ifg-prev]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentDevice, currentBrowser, currentStep);
      }
    });
  });

  // ─── EVENT: back to picker ───
  root.querySelectorAll('[data-ifg-back]').forEach(btn => {
    btn.addEventListener('click', () => {
      currentDevice = null;
      currentStep = 1;
      showPanel('picker');
    });
  });

  // ─── EVENT: done (utente conferma) ───
  root.querySelectorAll('[data-ifg-done]').forEach(btn => {
    btn.addEventListener('click', () => {
      setChannel('pwa', {
        status: 'installed',
        confirmedAt: new Date().toISOString(),
        device: `${currentDevice}-${currentBrowser}`,
        source: 'tutorial'
      });
      showPanel('done');
    });
  });

  // ─── EVENT: redo dalla schermata done ───
  root.querySelectorAll('[data-ifg-redo]').forEach(btn => {
    btn.addEventListener('click', () => {
      currentDevice = null;
      currentStep = 1;
      showPanel('picker');
    });
  });

  // ─── PREFERENZE NOTIFICHE — soft opt-in raccolto in localStorage ───
  // Naming generico riutilizzabile in Fase 3 (push reali) e in altre pagine
  // (account, footer). Le push vere arriveranno solo per chi ha messo true qui.
  const PREFS_KEY = 'frogames_notifications_prefs';

  function getPrefs() {
    try { return JSON.parse(localStorage.getItem(PREFS_KEY) || '{}'); }
    catch { return {}; }
  }
  function savePrefs(prefs) {
    try { localStorage.setItem(PREFS_KEY, JSON.stringify(prefs)); } catch {}
  }

  // Precompila i toggle se l'utente aveva già salvato preferenze prima
  const existingPrefs = getPrefs();
  if (existingPrefs.collectedAt) {
    root.querySelectorAll('[data-ifg-pref]').forEach(input => {
      const key = input.dataset.ifgPref;
      if (typeof existingPrefs[key] === 'boolean') {
        input.checked = existingPrefs[key];
      }
    });
  }

  root.querySelectorAll('[data-ifg-prefs-save]').forEach(btn => {
    btn.addEventListener('click', () => {
      const inputs = root.querySelectorAll('[data-ifg-pref]');
      const prefs = {
        collectedAt: new Date().toISOString(),
        source: 'install-tutorial'
      };
      inputs.forEach(i => { prefs[i.dataset.ifgPref] = i.checked; });
      savePrefs(prefs);

      // Mostra conferma
      const saved = root.querySelector('[data-ifg-prefs-saved]');
      if (saved) {
        saved.hidden = false;
        saved.style.opacity = '0';
        requestAnimationFrame(() => {
          saved.style.transition = 'opacity 0.4s ease';
          saved.style.opacity = '1';
        });
      }
      btn.disabled = true;
      btn.textContent = '✓ Salvate';
    });
  });

  // ─── ANDROID NATIVE: beforeinstallprompt ───
  // Chrome/Edge/Samsung Internet su Android emettono questo evento se la PWA
  // è installabile. Lo intercettiamo e mostriamo un bottone "Installa con un tap".
  let deferredPrompt = null;
  const magicBox = root.querySelector('[data-ifg-android-magic]');
  const magicBtn = root.querySelector('[data-ifg-android-magic-btn]');

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    if (magicBox) magicBox.hidden = false;
  });

  if (magicBtn) {
    magicBtn.addEventListener('click', async () => {
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      try {
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          setChannel('pwa', {
            status: 'installed',
            confirmedAt: new Date().toISOString(),
            device: 'android-native',
            source: 'magic-button'
          });
          showPanel('done');
        }
      } catch {}
      deferredPrompt = null;
      if (magicBox) magicBox.hidden = true;
    });
  }

  // ─── Conferma installazione anche quando l'OS la rileva da solo ───
  window.addEventListener('appinstalled', () => {
    setChannel('pwa', {
      status: 'installed',
      confirmedAt: new Date().toISOString(),
      device: isIOS ? 'ios' : (isSamsung ? 'android-samsung' : 'android-chrome'),
      source: 'os-event'
    });
  });
})();
